import React from 'react';
import { Box, Divider, Flex } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { FormLabel } from 'src/components/Common/FormComponent';
import { GeneralPolicyInfo, GeneralStatus } from '@Policy/Filters/General';
import { TargetUserGroups } from '@Policy/Components/TargetUserGroups';
import { useGmailTargetUserGroups } from '@Policy/hooks';

export const TargetUserGroupsGmail = () => {
  const props = useGmailTargetUserGroups();
  return <TargetUserGroups {...props} />;
};

const General = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <GeneralStatus
        skipScanJunkEmailFolderShow={true}
        mipEnableFeatureShow={false}
      />
      <Divider mt="22px" mb="22px" />
      <GeneralPolicyInfo />
      <Flex mt="23px" alignItems="flex-start">
        <FormLabel label={t('policy.label.policyTarget')} required />
        <TargetUserGroupsGmail />
      </Flex>
    </Box>
  );
};
export default React.memo(General);
